import * as actionTypes from "../../actionTypes";
import * as api from "../../../api/index";
import { toast } from "react-toastify";

export const GetWorkflowTemplateGroupsCERT = (page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  if (setLoading) setLoading(true);
  try {
    const { data, status } = await api.getWorkflowTemplateGroupsCERT(page, limit, query);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_WORKFLOW_TEMPLATE_GROUPS_CERT, payload: data.data });
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
  } finally {
    if (setLoading) setLoading(false);
  }
};

export const CreateWorkflowTemplateGroupCERT = (form, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  if (setLoading) setLoading(true);
  let statusCode;
  try {
    const { data, status } = await api.createWorkflowTemplateGroupCERT(form);
    statusCode = status;
    if (status === 201) {
      toast.success(data.message || 'Group created');
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
  } catch (error) {
    const serverMessage = error?.response?.data?.message
      || (Array.isArray(error?.response?.data?.error) ? error.response.data.error[0] : null);
    if (serverMessage) toast.error(serverMessage);
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    statusCode = error?.response?.status;
  } finally {
    if (setLoading) setLoading(false);
  }
  return { statusCode };
};

export const UpdateWorkflowTemplateGroupCERT = (id, form, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  if (setLoading) setLoading(true);
  let statusCode;
  try {
    const { data, status } = await api.updateWorkflowTemplateGroupCERT(id, form);
    statusCode = status;
    if (status === 200) {
      toast.success(data.message || 'Group updated');
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
  } finally {
    if (setLoading) setLoading(false);
  }
  return { statusCode };
};

export const SyncWorkflowTemplateGroupsCERT = (form, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  if (setLoading) setLoading(true);
  let statusCode;
  try {
    const { data, status } = await api.syncWorkflowTemplateGroupsCERT(form);
    statusCode = status;
    if (status === 200) {
      toast.success(data.message || 'Groups synced');
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
  } finally {
    if (setLoading) setLoading(false);
  }
  return { statusCode };
};

// Pulls the live group list from be-ai-agent-1 and inserts only the ones we
// don't already have (matched by external_group_id) — existing rows, their
// flags, and their allotments are left untouched.
export const SyncWorkflowTemplateGroupsFromSourceCERT = (setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  if (setLoading) setLoading(true);
  let statusCode, data;
  try {
    ({ data, status: statusCode } = await api.syncWorkflowTemplateGroupsFromSourceCERT());
    if (statusCode === 200) {
      const { created_count, skipped_count } = data?.data || {};
      toast.success(data.message || `Synced: ${created_count} added, ${skipped_count} already present`);
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
  } catch (error) {
    const serverMessage = error?.response?.data?.message;
    if (serverMessage) toast.error(serverMessage);
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    statusCode = error?.response?.status;
  } finally {
    if (setLoading) setLoading(false);
  }
  return { statusCode, data: data?.data };
};

export const GetWorkflowTemplateGroupAuthoritiesCERT = (id, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  if (setLoading) setLoading(true);
  try {
    const { data, status } = await api.getWorkflowTemplateGroupAuthoritiesCERT(id);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_WORKFLOW_TEMPLATE_GROUP_AUTHORITIES_CERT, payload: data.data });
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
  } finally {
    if (setLoading) setLoading(false);
  }
};

export const AllotWorkflowTemplateGroupToAuthoritiesCERT = (id, form, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  if (setLoading) setLoading(true);
  let statusCode;
  try {
    const { data, status } = await api.allotWorkflowTemplateGroupToAuthoritiesCERT(id, form);
    statusCode = status;
    if (status === 200) {
      toast.success(data.message || 'Group allotted');
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
  } finally {
    if (setLoading) setLoading(false);
  }
  return { statusCode };
};

export const UpdateWorkflowTemplateGroupAuthorityAllotmentCERT = (id, authorityUserId, form, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  if (setLoading) setLoading(true);
  let statusCode;
  try {
    const { data, status } = await api.updateWorkflowTemplateGroupAuthorityAllotmentCERT(id, authorityUserId, form);
    statusCode = status;
    if (status === 200) {
      toast.success(data.message || 'Allotment updated');
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
  } finally {
    if (setLoading) setLoading(false);
  }
  return { statusCode };
};

export const RemoveWorkflowTemplateGroupAuthorityAllotmentCERT = (id, authorityUserId, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  if (setLoading) setLoading(true);
  let statusCode;
  try {
    const { data, status } = await api.removeWorkflowTemplateGroupAuthorityAllotmentCERT(id, authorityUserId);
    statusCode = status;
    if (status === 200) {
      toast.success(data.message || 'Allotment removed');
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
  } finally {
    if (setLoading) setLoading(false);
  }
  return { statusCode };
};
